import styled from 'styled-components';

import { Icon as AuiIcon } from '@soluto-private/mx-asurion-ui-react';

import { ReactComponent as CheckCircle } from './assets/check-circle-1.svg';

const Icon = styled(AuiIcon)`
  margin-bottom: 12px;
`;

export const CheckCircleIcon = () => (
  <Icon size="xxlarge" src={<CheckCircle />} />
);
